module.exports = __webpack_public_path__ + "static/img/action.7f09829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/atenCamera/action.png
// module id = q99E
// module chunks = 0